
import { Button, IconButton } from '@mui/material';
import './indoor.css';
import indoor1 from "../../../../../assets/Indoors/in1.jpeg";
import indoor2 from "../../../../../assets/Indoors/in2.jpeg";
import indoor3 from "../../../../../assets/Indoors/in3.jpeg";
import indoor4 from "../../../../../assets/Indoors/in4.jpeg";
import indoor5 from "../../../../../assets/Indoors/in5.jpeg";
import in51 from "../../../../../assets/Indoors/Monstera-s.jpeg";
import in52 from "../../../../../assets/Indoors/Monstera-md.jpeg";

import indoor6 from "../../../../../assets/Indoors/in6.jpeg";
import indoor7 from "../../../../../assets/Indoors/in7.jpeg";
import indoor8 from "../../../../../assets/Indoors/in8.jpeg";
import indoor9 from "../../../../../assets/Indoors/in9.jpeg";
import indoor91 from "../../../../../assets/Indoors/red-dracnea.jpeg";
import indoor10 from "../../../../../assets/Indoors/in10.jpeg";
import indoor101 from "../../../../../assets/Indoors/white-and-green-dracnea.jpeg";
import indoor11 from "../../../../../assets/Indoors/in11.jpeg";
import indoor111 from "../../../../../assets/Indoors/bonsaii-small.jpeg";
import indoor112 from "../../../../../assets/Indoors/bonsaii-medium.jpeg";
import indoor113 from "../../../../../assets/Indoors/bonsaii-large.jpeg";
import indoor114 from "../../../../../assets/Indoors/bonsai-1 (1).jpeg";
import indoor115 from "../../../../../assets/Indoors/bonsai-1 (9).jpeg";
import indoor116 from "../../../../../assets/Indoors/bonsai-1 (8).jpeg";
import indoor117 from "../../../../../assets/Indoors/bonsai-1 (7).jpeg";
import indoor118 from "../../../../../assets/Indoors/bonsai-1 (6).jpeg";
import indoor119 from "../../../../../assets/Indoors/bonsai-1 (5).jpeg";
import indoor1191 from "../../../../../assets/Indoors/bonsai-1 (4).jpeg";
import indoor1192 from "../../../../../assets/Indoors/bonsai-1 (3).jpeg";
import indoor1193 from "../../../../../assets/Indoors/bonsai-1 (2).jpeg";
import indoor1194 from "../../../../../assets/Indoors/bonsai-1 (11).jpeg";
import indoor1195 from "../../../../../assets/Indoors/bonsai-1 (10).jpeg";

import indoor12 from "../../../../../assets/Indoors/in12.jpeg";
import indoor121 from "../../../../../assets/Indoors/ficus-panda1.jpeg";
import indoor13 from "../../../../../assets/Indoors/in13.jpeg";
import indoor131 from "../../../../../assets/Indoors/ficus-benjamin-det.jpeg";
import indoor14 from "../../../../../assets/Indoors/in14.jpeg";
import indoor141 from "../../../../../assets/Indoors/croton1.jpeg";
import indoor15 from "../../../../../assets/Indoors/in15.jpeg";
import indoor16 from "../../../../../assets/Indoors/in16.jpeg";
import indoor17 from "../../../../../assets/Indoors/in17.jpeg";
import indoor171 from "../../../../../assets/Indoors/sanseveria-det.jpeg";


import indoor18 from "../../../../../assets/Indoors/in18.jpeg";
import indoor181 from "../../../../../assets/Indoors/cactus1.jpeg";
import indoor182 from "../../../../../assets/Indoors/cactus2.jpeg";
import indoor183 from "../../../../../assets/Indoors/cactus3.jpeg";
import indoor184 from "../../../../../assets/Indoors/cactus4.jpeg";
import indoor185 from "../../../../../assets/Indoors/cactus5.jpeg"


import indoor19 from "../../../../../assets/Indoors/asparagus.jpg";
import indoor191 from "../../../../../assets/Indoors/asparagus2.jpeg";
import indoor20 from "../../../../../assets/Indoors/sprengeri-asparagus.webp";
import indoor201 from "../../../../../assets/Indoors/sprengeri-asparagus2.jpeg";
import indoor21 from "../../../../../assets/Indoors/aucuba-japonica.webp";
import indoor211 from "../../../../../assets/Indoors/japonica-sm.jpeg";
import indoor212 from "../../../../../assets/Indoors/aucuba-japonica-md.jpeg";
import indoor213 from "../../../../../assets/Indoors/japonica-lg.jpeg";
import indoor22 from "../../../../../assets/Indoors/furcraea.webp";
import indoor221 from "../../../../../assets/Indoors/furcrarea-sm.jpeg";
import indoor222 from "../../../../../assets/Indoors/furcraea2-md.jpeg";
import indoor223 from "../../../../../assets/Indoors/furcrarea-lg.jpeg";


import indoor23 from "../../../../../assets/Indoors/green-agave.webp";
import indoor231 from "../../../../../assets/Indoors/green-agave2.jpeg";
import indoor232 from "../../../../../assets/Indoors/green-agave3.jpeg";

import indoor24 from "../../../../../assets/Indoors/agave-variegata.webp";
import indoor241 from "../../../../../assets/Indoors/agave-md.jpeg";
import indoor242 from "../../../../../assets/Indoors/agave-variegata2-md.jpeg";

import indoor25 from "../../../../../assets/Indoors/blue-agave.webp";
import indoor251 from "../../../../../assets/Indoors/blue-agave-sm.jpeg";
import indoor252 from "../../../../../assets/Indoors/blue-agave-md.jpeg";
import indoor253 from "../../../../../assets/Indoors/blue-agave-lg.jpeg";

import indoor26 from "../../../../../assets/Indoors/yucca-desmetiana.webp";
import indoor261 from "../../../../../assets/Indoors/yucca-desmetiana2.jpeg";

import indoor27 from "../../../../../assets/Indoors/aspidistra.jpg";
import indoor271 from "../../../../../assets/Indoors/aspidistra2.jpeg";

import indoor28 from "../../../../../assets/Indoors/alocasia-cucullata.jpg";
import indoor281 from "../../../../../assets/Indoors/alocasia-cucullata2.jpeg";


import indoor29 from "../../../../../assets/Indoors/philodendron.webp";
import indoor291 from "../../../../../assets/Indoors/philodendron2.jpeg";
import indoor292 from "../../../../../assets/Indoors/philo-md.jpeg";

import indoor30 from "../../../../../assets/Indoors/dracanea-draco.webp";
import indoor301 from "../../../../../assets/Indoors/dracaena-draco2.jpeg";

import indoor31 from "../../../../../assets/Indoors/dracaena-frag.jpg";
import indoor311 from "../../../../../assets/Indoors/draca-frag-sm.jpeg";
import indoor312 from "../../../../../assets/Indoors/draca-frag-md.jpeg";
import indoor313 from "../../../../../assets/Indoors/draca-frag-lg.jpeg";

import indoor321 from "../../../../../assets/Indoors/sanchezia-sm.jpeg";
import indoor322 from "../../../../../assets/Indoors/sanchezia-md.jpeg";
import indoor32 from "../../../../../assets/Indoors/sanchezia.jpg";

import indoor331 from "../../../../../assets/Indoors/chamedorea-sm.jpeg";
import indoor332 from "../../../../../assets/Indoors/chamaedorea-md.jpeg";
import indoor33 from "../../../../../assets/Indoors/chamaedorea.webp";

import indoor35 from "../../../../../assets/Indoors/kenita.jpg";
import indoor352 from "../../../../../assets/Indoors/kenita-sm.jpeg";
import indoor351 from "../../../../../assets/Indoors/kenita-md.jpeg";

import indoor36 from "../../../../../assets/Indoors/Euphorbia-lactea.jpg";
import indoor362 from "../../../../../assets/Indoors/Euphorbia-lactea-sm.jpeg";
import indoor361 from "../../../../../assets/Indoors/Euphorbia-lactea-md.jpeg";


import indoor37 from "../../../../../assets/Indoors/Euphorbia-trigona.webp";
import indoor371 from "../../../../../assets/Indoors/Euphorbia-trigona-sm.jpeg";
import indoor372 from "../../../../../assets/Indoors/Euphorbia-trigona -md.jpeg";
import indoor373 from "../../../../../assets/Indoors/Euphorbia-trigona -lg.jpeg";
import indoor374 from "../../../../../assets/Indoors/Euphorbia-trigona -xl.jpeg";

import indoor38 from "../../../../../assets/Indoors/Rhapis-excelsa.jpg";
import indoor382 from "../../../../../assets/Indoors/Rhapis-excelsa-md.jpeg";
import indoor381 from "../../../../../assets/Indoors/Rhapis-excelsa-sm.jpeg";

import indoor39 from "../../../../../assets/Indoors/Pilosocereus.webp";
import indoor391 from "../../../../../assets/Indoors/pilo-sm.jpeg";
import indoor392 from "../../../../../assets/Indoors/pilo-md.jpeg";

import indoor40 from "../../../../../assets/Indoors/Opuntia-microdasys.webp";
import indoor401 from "../../../../../assets/Indoors/Opuntia-sm.jpeg";
import indoor402 from "../../../../../assets/Indoors/Opuntia-md.jpeg";
import indoor403 from "../../../../../assets/Indoors/Opuntia-lg.jpeg";
import indoor404 from "../../../../../assets/Indoors/opuntia-xs.jpeg";

import indoor41 from "../../../../../assets/Indoors/Pachira.webp";
import indoor411 from "../../../../../assets/Indoors/Pachira-sm.jpeg";
import indoor412 from "../../../../../assets/Indoors/pachira-md.jpeg";


import indoor42 from "../../../../../assets/Indoors/Strelitzia.webp";
import indoor421 from "../../../../../assets/Indoors/Strelitzia-sm.jpeg";
import indoor422 from "../../../../../assets/Indoors/Strelitzia-md.jpeg";
import indoor423 from "../../../../../assets/Indoors/Strelitzia-lg.jpeg";
import indoor424 from "../../../../../assets/Indoors/Strelitzia-xl.jpeg";

import indoor43 from "../../../../../assets/Indoors/peace-lily.jpg";
import indoor431 from "../../../../../assets/Indoors/peace-lily-sm.jpeg";
import indoor432 from "../../../../../assets/Indoors/peace-lily-md.jpeg";

import indoor44 from "../../../../../assets/Indoors/echino.webp";
import indoor441 from "../../../../../assets/Indoors/echino-sm.jpeg";
import indoor442 from "../../../../../assets/Indoors/echino-md.jpeg";
import indoor443 from "../../../../../assets/Indoors/echino-l.jpeg";
import indoor444 from "../../../../../assets/Indoors/echino-xl.jpeg";

import indoor45 from "../../../../../assets/Indoors/Dracaena-Marginata.avif";
import indoor451 from "../../../../../assets/Indoors/Dracaena-Marginata1.jpeg";

import indoor46 from "../../../../../assets/Indoors/Dracaena-reflexa.webp";
import indoor461 from "../../../../../assets/Indoors/Dracaena-reflexa1.jpeg";

import indoor47 from "../../../../../assets/Indoors/bonsaii-small.jpeg";
import indoor471 from "../../../../../assets/Indoors/bonsaii-s-sm.jpeg";
import indoor472 from "../../../../../assets/Indoors/bonsaii-s-md.jpeg";
import indoor473 from "../../../../../assets/Indoors/bonsaii-s-large.jpeg"

import indoor48 from "../../../../../assets/Indoors/dracaena-marginata.webp";
import indoor481 from "../../../../../assets/Indoors/dracaena-marginata-sm.jpeg";
import indoor482 from "../../../../../assets/Indoors/dracaena-marginata-md.jpeg";

import indoor49 from "../../../../../assets/Indoors/Ficus-lyrata.webp";
import indoor491 from "../../../../../assets/Indoors/Ficus-lyrata-sm.jpeg";
import indoor492 from "../../../../../assets/Indoors/Ficus-lyrata-md.jpeg";


import indoor50 from "../../../../../assets/Indoors/Caryota-mitis.webp";
import indoor501 from "../../../../../assets/Indoors/Caryota-mitis-det.jpeg";

import indoor51 from "../../../../../assets/Indoors/ficus-benjamina-cage.jpg";
import indoor511 from "../../../../../assets/Indoors/ficus-benjamina cage-sm.jpeg";
import indoor512 from "../../../../../assets/Indoors/ficus-benjamina cage-md.jpeg";
import indoor513 from "../../../../../assets/Indoors/ficus-benjamina cage-lg.jpeg"

import indoor52 from "../../../../../assets/Indoors/ficus-king.webp";
import indoor521 from "../../../../../assets/Indoors/ficus-king-det.jpeg";

import indoor53 from "../../../../../assets/Indoors/ficus-benj.jpg";
import indoor531 from "../../../../../assets/Indoors/ficus-benj-det.jpeg";

import indoor54 from "../../../../../assets/Indoors/ficus-stresse.jpg";
import indoor541 from "../../../../../assets/Indoors/ficus-stress-sm.jpeg";
import indoor542 from "../../../../../assets/Indoors/ficus-stress-md.jpeg";

import indoor55 from "../../../../../assets/Indoors/Schefflera-arboricola.jpg";
import indoor551 from "../../../../../assets/Indoors/Schefflera-arboricola-det.jpeg";

import indoor56 from "../../../../../assets/Indoors/ficus-8.avif";
import indoor561 from "../../../../../assets/Indoors/ficus-8-small.jpeg";
import indoor562 from "../../../../../assets/Indoors/ficus-8-md.jpeg";

import indoor57 from "../../../../../assets/Indoors/ficus-net.jpg";
import indoor571 from "../../../../../assets/Indoors/ficus-net-det.jpeg";

import indoor58 from "../../../../../assets/Indoors/Pachypodium-lamerei.webp";
import indoor581 from "../../../../../assets/Indoors/Pachypodium lamerei-sm.jpeg";
import indoor582 from "../../../../../assets/Indoors/Pachypodium lamerei-md.jpeg";
import indoor583 from "../../../../../assets/Indoors/Pachypodium lamerei-lg.jpeg";

import indoor59 from "../../../../../assets/Indoors/beaucarnea.webp";
import indoor591 from "../../../../../assets/Indoors/beaucarnea-xs.jpeg";
import indoor592 from "../../../../../assets/Indoors/beaucarnea-sm.jpeg";
import indoor593 from "../../../../../assets/Indoors/beaucarnea-md.jpeg";
import indoor594 from "../../../../../assets/Indoors/beaucarnea-l.jpeg";
import indoor595 from "../../../../../assets/Indoors/beaucarnea-xl.jpeg";
import indoor596 from "../../../../../assets/Indoors/beaucarnea-xxl.jpeg";
import indoor597 from "../../../../../assets/Indoors/beaucarnea-xxxl.jpeg";
import indoor598 from "../../../../../assets/Indoors/beaucarnea-xxxxl.jpeg";

import indoor60 from "../../../../../assets/Indoors/areca.webp";
import indoor601 from "../../../../../assets/Indoors/areca-xs.jpeg";
import indoor602 from "../../../../../assets/Indoors/areca-s.jpeg";
import indoor603 from "../../../../../assets/Indoors/areca-m.jpeg";
import indoor604 from "../../../../../assets/Indoors/areca-l.jpeg";
import indoor605 from "../../../../../assets/Indoors/areca-xl.jpeg";


import indoor61 from "../../../../../assets/Indoors/ficus-elastica-red.webp";
import indoor611 from "../../../../../assets/Indoors/ficus-elastica-red-sm.jpeg";
import indoor612 from "../../../../../assets/Indoors/ficus-elastica-red-md.jpeg";

import indoor62 from "../../../../../assets/Indoors/elastica-green-white.jpg";
import indoor621 from "../../../../../assets/Indoors/elastica-green-white-sm.jpeg";
import indoor622 from "../../../../../assets/Indoors/elastica-green-white-md.jpeg";
import indoor623 from "../../../../../assets/Indoors/elastica-green-white-lg.jpeg";

import indoor63 from "../../../../../assets/Indoors/ficus-elastica-green.webp";
import indoor631 from "../../../../../assets/Indoors/elastica-green-sm.jpeg";
import indoor632 from "../../../../../assets/Indoors/elastica-green-md.jpeg";

import indoor64 from "../../../../../assets/Indoors/bamboo-variegated.jpg";
import indoor641 from "../../../../../assets/Indoors/bamboo-variegated-det.jpeg";

import indoor65 from "../../../../../assets/Indoors/fiucs-hawaii-tige.jpg";
import indoor651 from "../../../../../assets/Indoors/ficus-hawaii-tige-sm.jpeg";
import indoor652 from "../../../../../assets/Indoors/ficus-hawaii-tige-md.jpeg"

import indoor66 from "../../../../../assets/Indoors/ficus-hawaii-touffe.jpg";
import indoor661 from "../../../../../assets/Indoors/ficus hawaii-touffe-det.jpeg";

import indoor67 from "../../../../../assets/Indoors/ficus-panda-tige.webp";
import indoor671 from "../../../../../assets/Indoors/ficus-panda-tige1.jpeg";

import indoor68 from "../../../../../assets/Indoors/ficus-panda-pyramid.webp";
import indoor681 from "../../../../../assets/Indoors/ficus-panda-pyramid1.jpeg";


import indoor69 from "../../../../../assets/Indoors/ficus-panda-boule.webp";
import indoor691 from "../../../../../assets/Indoors/ficus-panda-boule1.jpeg";


import indoor70 from "../../../../../assets/Indoors/ficus-panda-3heads.webp";
import indoor701 from "../../../../../assets/Indoors/ficus-panda-3heads1.jpeg";

import indoor71 from "../../../../../assets/Indoors/ficus-panda-multiheads.jpg";
import indoor711 from "../../../../../assets/Indoors/ficus-panda-multiheads1.jpeg";

import BackIcon from '../../../../../components/back/back';
import { useNavigate } from 'react-router-dom';

type GalleryImage = {
    src: string;
    size?: string;
    name?: string;
};


type IndoorFamily = {
    id: number;
    name: string;
    img: string;
    description: string;
    gallery: GalleryImage[];
};

export const IndoorFamilies: IndoorFamily[] = [
    {
        id: 1,
        name: "Areca",
        img: indoor1,
        description: "A lush palm with arching fronds, perfect for bright indoor spaces.",
        gallery: [{ src: indoor1 }],
    },

    {
        id: 5,
        name: "Monstera",
        img: indoor5,
        description: "Famous for its split leaves, Monstera is a trendy indoor favorite.",
        gallery: [
            { src: indoor291, size: "small" },
            { src: in52, size: "medium" },
        ],
    },


    {
        id: 8,
        name: "Green Dracaena",
        img: indoor8,
        description: "Low-maintenance plant with long green foliage.",
        gallery: [{ src: indoor8 }],
    },
    {
        id: 9,
        name: "Red Dracaena",
        img: indoor9,
        description: "Striking red-edged leaves, adding bold color indoors.",
        gallery: [{ src: indoor91 }],
    },
    {
        id: 10,
        name: "White and Green Dracaena",
        img: indoor10,
        description: "Beautiful variegated leaves with green and white stripes.",
        gallery: [{ src: indoor101 }],
    },
    {
        id: 11,
        name: "Ficus Bonsai",
        img: indoor11,
        description: "Miniature tree that adds elegance and serenity indoors.",
        gallery: [
            { src: indoor111, size: 'small', name: "ficus Bonsaii" },
            { src: indoor112, size: 'medium', name: "ficus Bonsaii" },
            { src: indoor113, size: 'large', name: "ficus Bonsaii" },
            { src: indoor471, size: 'small', name: "ficus Bonsaii S" },
            { src: indoor472, size: 'medium', name: "ficus Bonsaii S" },
            { src: indoor473, size: 'large', name: "ficus Bonsaii S" },
            { src: indoor114 },
            { src: indoor115 },
            { src: indoor116 },
            { src: indoor117 },
            { src: indoor118 },
            { src: indoor119 },
            { src: indoor1191 },
            { src: indoor1192 },
            { src: indoor1193 },
            { src: indoor1194 },
            { src: indoor1195 },

        ],
    },

    {
        id: 12,
        name: "Ficus Panda",
        img: indoor12,
        description: "A rounded, lush ficus with dense green leaves.",
        gallery: [{ src: indoor121 }],
    },
    {
        id: 13,
        name: "Ficus Benjamina",
        img: indoor13,
        description: "Also known as weeping fig, with glossy leaves and flowing branches.",
        gallery: [{ src: indoor131 }],
    },
    {
        id: 14,
        name: "Croton",
        img: indoor14,
        description: "Colorful foliage with reds, yellows, and oranges.",
        gallery: [{ src: indoor141 }],
    },
    {
        id: 15,
        name: "Yucca",
        img: indoor15,
        description: "Tough plant with sharp sword-like leaves, ideal for minimal care.",
        gallery: [{ src: indoor15 }],
    },
    {
        id: 16,
        name: "Ficus Hawaii",
        img: indoor16,
        description: "Attractive variegated ficus with tropical vibes.",
        gallery: [{ src: indoor16 }],
    },
    {
        id: 17,
        name: "Sansevieria",
        img: indoor17,
        description: "Also called Snake Plant, perfect for beginners and air purification.",
        gallery: [{ src: indoor171 }],
    },
    {
        id: 18,
        name: "Cactus",
        img: indoor18,
        description: "Classic desert plant, thrives in sunlight with minimal watering.",
        gallery: [
            { src: indoor181 },
            { src: indoor182 },
            { src: indoor183 },
            { src: indoor184 },
            { src: indoor185 },


        ],
    },
    {
        id: 44,
        name: "Echinocactus",
        img: indoor44,
        description: "Echinocactus, commonly known as the golden barrel cactus, is a round, spiny cactus with striking ribbed patterns. It prefers bright sunlight and minimal water, making it a hardy and eye-catching addition to succulent collections.",
        gallery: [
            { src: indoor441, size: "small" },
            { src: indoor442, size: "medium" },
            { src: indoor443, size: "large" },
            { src: indoor444, size: "xl" },
        ],
    },
    {
        id: 19,
        name: "Asparagus",
        img: indoor19,
        description: "Feathery foliage and delicate look, used as ornamental green.",
        gallery: [{ src: indoor191 }],
    },
    {
        id: 20,
        name: "Sprengeri Asparagus",
        img: indoor20,
        description: "Light, airy plant often used in hanging pots and arrangements.",
        gallery: [{ src: indoor201 }],
    },
    {
        id: 21,
        name: "Aucuba Japonica",
        img: indoor21,
        description: "Spotted gold leaves, great for low-light indoor areas.",
        gallery: [
            { src: indoor211, size: 'small' },
            { src: indoor212, size: 'medium' },
            { src: indoor213, size: 'large' },
        ],
    },
    {
        id: 22,
        name: "Furcraea",
        img: indoor22,
        description: "A striking plant with spiky rosettes and dramatic appearance.",
        gallery: [
            { src: indoor221, size: 'small' },
            { src: indoor222, size: 'medium' },
            { src: indoor223, size: 'large' },
        ],
    },
    {
        id: 23,
        name: "Green Agave",
        img: indoor23,
        description: "Succulent plant with rosette leaves, very low maintenance.",
        gallery: [
            { src: indoor231 },
            { src: indoor232 },
        ],
    },
    {
        id: 24,
        name: "Agave Variegata",
        img: indoor24,
        description: "Striped version of agave, adds contrast and structure.",
        gallery: [
            { src: indoor242, size: "small" },
            { src: indoor241, size: "medium" },

        ],
    },
    {
        id: 25,
        name: "Blue Agave",
        img: indoor25,
        description: "A striking succulent known for its bold, blue-gray leaves arranged in a symmetrical rosette, ideal for modern interiors and minimal care.",
        gallery: [
            { src: indoor251, size: "small" },
            { src: indoor252, size: "medium" },
            { src: indoor253, size: "large" },
        ],
    },
    {
        id: 26,
        name: "Yucca Desmetiana",
        img: indoor26,
        description: "Compact yucca variety with red-tinged foliage.",
        gallery: [{ src: indoor261 }],
    },
    {
        id: 27,
        name: "Aspidistra",
        img: indoor27,
        description: "Also called cast iron plant, survives in poor light and neglect.",
        gallery: [{ src: indoor271 }],
    },
    {
        id: 28,
        name: "Alocasia Cucullata",
        img: indoor28,
        description: "Heart-shaped leaves, also known as Buddha’s Hand.",
        gallery: [{ src: indoor281 }],
    },
    {
        id: 29,
        name: "Philodendron",
        img: indoor29,
        description: "Lush climber with vibrant green foliage.",
        gallery: [
            { src: in51, size: "small" },

            { src: indoor292, size: "medium" },
        ],
    },
    {
        id: 30,
        name: "Dracaena Draco",
        img: indoor30,
        description: "Dragon tree with thick trunk and spiky leaves.",
        gallery: [{ src: indoor301 }],
    },
    {
        id: 31,
        name: "Dracaena fragrans",
        img: indoor31,
        description: "Dracaena fragrans, also known as the corn plant, is a popular indoor plant with glossy green leaves and a tall cane-like stem. It’s easy to care for and thrives in low to medium light.",
        gallery: [
            { src: indoor313, size: "small" },
            { src: indoor312, size: "medium" },
            { src: indoor311, size: "large" },
        ],
    },
    {
        id: 45,
        name: "Dracaena Marginata",
        img: indoor45,
        description: "Dracaena marginata, also known as the dragon tree, is a striking indoor plant with slender, upright stems topped by narrow, arching leaves edged in red or burgundy. It’s hardy, low-maintenance, and thrives in bright, indirect light.",
        gallery: [
            { src: indoor451 },
        ],
    },
    {
        id: 46,
        name: "Dracaena Reflexa",
        img: indoor46,
        description: "Dracaena reflexa, often called the song of India, is a tropical plant known for its glossy, pointed leaves edged with yellow or cream. It’s an attractive, easy-care plant that brightens indoor spaces with its variegated foliage.",
        gallery: [
            { src: indoor461 },
        ],
    },

    {
        id: 34,
        name: "Chamaedorea",
        img: indoor33,
        description: "Chamaedorea, commonly known as the parlor palm, is a compact and elegant palm with feathery fronds. It’s highly adaptable and perfect for brightening up indoor spaces.",
        gallery: [
            { src: indoor331, size: "small" },
            { src: indoor332, size: "medium" },
        ],
    },
    {
        id: 32,
        name: "Sanchezia",
        img: indoor32,
        description: "Sanchezia is an ornamental plant with striking green leaves patterned with bright yellow veins. It’s often grown for its bold foliage and vibrant tubular flowers.",
        gallery: [
            { src: indoor321, size: "small" },
            { src: indoor322, size: "medium" },
        ],
    },
    {
        id: 35,
        name: "Kentia Palm",
        img: indoor35,
        description: "The Kentia Palm (Howea forsteriana) is an elegant indoor palm with long, arching fronds that create a tropical feel. It’s slow-growing, tolerant of low light, and one of the best palms for indoor decoration.",
        gallery: [
            { src: indoor351, size: "small" },
            { src: indoor352, size: "medium" },
        ],
    },
    {
        id: 36,
        name: "Euphorbia lactea",
        img: indoor36,
        description: "Euphorbia lactea, also known as the mottled spurge, is a striking succulent with triangular green stems marbled with white. Often grafted into colorful crested forms, it’s grown as an ornamental for its unusual shapes.",
        gallery: [
            { src: indoor362, size: "small" },
            { src: indoor361, size: "medium" },
        ],
    },
    {
        id: 37,
        name: "Euphorbia trigona",
        img: indoor37,
        description: "Euphorbia trigona, also called the African milk tree, is a tall, branching succulent with upright green stems and small leaves along the ridges. It’s hardy, low-maintenance, and makes an excellent architectural houseplant.",
        gallery: [
            { src: indoor374, size: "small" },
            { src: indoor373, size: "medium" },
            { src: indoor372, size: "large" },
            { src: indoor371, size: "xl" },
        ],
    },
    {
        id: 38,
        name: "Rhapis excelsa",
        img: indoor38,
        description: "Rhapis excelsa, known as the lady palm, is a refined indoor palm with slender, fan-shaped leaves. It’s highly adaptable, thrives in low light, and adds a touch of sophistication to homes and offices.",
        gallery: [
            { src: indoor381, size: "small" },
            { src: indoor382, size: "medium" },
        ],
    },
    {
        id: 39,
        name: "Pilosocereus",
        img: indoor39,
        description: "Pilosocereus is a striking columnar cactus with tall, blue-green stems often covered in golden spines. It thrives in bright light and dry conditions, making it a bold and low-maintenance indoor or outdoor plant.",
        gallery: [
            { src: indoor391, size: "small" },
            { src: indoor392, size: "medium" },
        ],
    },
    {
        id: 40,
        name: "Opuntia microdasys",
        img: indoor40,
        description: "Opuntia microdasys, commonly called bunny ears cactus, features flat, oval pads covered with tiny glochids that look soft but are prickly. It’s drought-tolerant, sun-loving, and adds a playful touch to desert-style plant collections.",
        gallery: [
            { src: indoor404, size: "xs" },
            { src: indoor401, size: "small" },
            { src: indoor402, size: "medium" },
            { src: indoor403, size: "large" },
        ],
    },
    {
        id: 41,
        name: "Pachira",
        img: indoor41,
        description: "Pachira aquatica, often called the money tree, is a popular indoor plant believed to bring good luck and prosperity. It features braided trunks and lush, green leaves, thriving in bright, indirect light.",
        gallery: [
            { src: indoor411, size: "small" },
            { src: indoor412, size: "medium" },
        ],
    },
    {
        id: 42,
        name: "Strelitzia",
        img: indoor42,
        description: "Strelitzia, known as the bird of paradise, is a dramatic tropical plant with large, banana-like leaves. When mature, it produces unique orange and blue flowers resembling a bird in flight, adding an exotic feel to interiors.",
        gallery: [
            { src: indoor421, size: "small" },
            { src: indoor422, size: "medium" },
            { src: indoor423, size: "large" },
            { src: indoor424, size: "xl" },
        ],
    },
    {
        id: 43,
        name: "Peace Lily",
        img: indoor43,
        description: "The Peace Lily (Spathiphyllum) is a graceful indoor plant admired for its lush green leaves and elegant white spathes that resemble flowers. It thrives in low light, helps purify the air, and adds a calming touch to homes and offices.",
        gallery: [
            { src: indoor431, size: "small" },
            { src: indoor432, size: "medium" },
        ],
    },

    {
        id: 48,
        name: "Dracaena Marginata Tricolor",
        img: indoor48,
        description: "The Dracaena Marginata Tricolor is a striking indoor plant with long, narrow green leaves edged in cream and red. Its colorful foliage makes it a popular choice for adding height and vibrancy to interiors. It is hardy, low-maintenance, and thrives in bright, indirect light.",
        gallery: [
            { src: indoor481, size: "small" },
            { src: indoor482, size: "medium" },
        ],
    },
    {
        id: 49,
        name: "Ficus lyrata",
        img: indoor49,
        description: "The Ficus lyrata, commonly known as the fiddle-leaf fig, is admired for its large, violin-shaped leaves and bold presence. Perfect as a statement plant, it thrives in bright, filtered light and adds elegance to modern interiors.",
        gallery: [
            { src: indoor492, size: "small" },
            { src: indoor491, size: "medium" },
        ],
    },
    {
        id: 50,
        name: "Caryota mitis",
        img: indoor50,
        description: "The Caryota mitis, also called the fishtail palm, is a tropical plant recognized for its uniquely shaped leaves that resemble a fish’s tail. It brings a lush, exotic vibe to indoor spaces and prefers bright, indirect light with regular watering.",
        gallery: [
            { src: indoor501 },
        ],
    },
    {
        id: 51,
        name: "Ficus benjamina Cage",
        img: indoor51,
        description: "The Ficus benjamina Cage is a decorative variety of the weeping fig, often styled in braided or caged forms. It has glossy green leaves and a graceful growth habit, making it ideal for adding greenery with a sculptural touch to interiors.",
        gallery: [
            { src: indoor513, size: "small" },
            { src: indoor512, size: "medium" },
            { src: indoor511, size: "large" },
        ],
    },
    {
        id: 52,
        name: "Ficus binnendijkii Amstel King",
        img: indoor52,
        description: "The Ficus binnendijkii Amstel King is a hardy indoor plant with long, narrow, glossy green leaves. Its upright and bushy form makes it an excellent choice for filling corners and adding tropical greenery indoors. It tolerates lower light conditions compared to other ficus varieties.",
        gallery: [
            { src: indoor521 },
        ],
    },
    {
        id: 53,
        name: "Ficus benj. Exotica Spiral",
        img: indoor53,
        description: "The Ficus benjamina Exotica Spiral is a stylish variety of the weeping fig, often trained into a spiral trunk form. With glossy green leaves and an elegant shape, it is both decorative and functional, adding a sophisticated touch to homes and offices.",
        gallery: [
            { src: indoor531 },
        ],
    },
    {
        id: 54,
        name: "Ficus benjamina Stresse",
        img: indoor54,
        description: "The Ficus benjamina Stresse is a unique variety of the weeping fig known for its distinctive leaf shape and graceful growth. It adds a refreshing green accent indoors and adapts well to various light conditions, making it a versatile decorative plant.",
        gallery: [
            { src: indoor541, size: "small" },
            { src: indoor542, size: "medium" },
        ],
    },
    {
        id: 56,
        name: "Ficus Bonsaii 8",
        img: indoor56,
        description: "The Ficus Bonsai is a miniature version of the ficus tree, admired for its thick trunk, aerial roots, and glossy green leaves. It symbolizes harmony and balance, making it a popular choice for bonsai enthusiasts and indoor décor.",
        gallery: [
            { src: indoor561, size: "small" },
            { src: indoor562, size: "medium" },
        ],
    },
    {
        id: 57,
        name: "Ficus Bonsai Net shape",
        img: indoor57,
        description: "This unique Ficus Bonsai, trained into a net-like shape, combines artistic design with the natural beauty of bonsai. Its sculpted form and dense foliage bring elegance and creativity to any indoor setting.",
        gallery: [
            { src: indoor571 },
        ],
    },
    {
        id: 55,
        name: "Schefflera arboricola",
        img: indoor55,
        description: "The Schefflera arboricola, commonly called the dwarf umbrella tree, features clusters of glossy, hand-shaped leaves. It is easy to grow, adaptable to different light levels, and brings a lush, tropical look to indoor spaces.",
        gallery: [
            { src: indoor551 },
        ],
    },

    {
        id: 58,
        name: "Pachypodium lamerei",
        img: indoor58,
        description: "Pachypodium lamerei, also known as the Madagascar Palm, is a striking succulent with a thick, spiny trunk and a crown of long, narrow leaves. Despite its palm-like appearance, it is not a true palm but a hardy, drought-tolerant plant that thrives indoors with plenty of light.",
        gallery: [
            { src: indoor581, size: "small" },
            { src: indoor582, size: "medium" },
            { src: indoor583, size: "large" },
        ],
    },
    {
        id: 59,
        name: "Beaucarnea Recurvata",
        img: indoor59,
        description: "Beaucarnea recurvata, commonly known as the Ponytail Palm, is a unique and elegant plant with a swollen base that stores water and long, cascading leaves resembling a ponytail. It is low-maintenance, drought-tolerant, and thrives in bright indoor spaces, making it a perfect choice for modern homes and offices.",
        gallery: [
            { src: indoor591, size: "small" },
            { src: indoor592, size: "medium" },
            { src: indoor593, size: "large" },
            { src: indoor594, size: "xl" },
            { src: indoor595, size: "xxl" },
            { src: indoor596, size: "xxxl" },
            { src: indoor597, size: "xxxxl" },
        ],
    },
    {
        id: 60,
        name: "Areca",
        img: indoor60,
        description: "A graceful indoor palm with feathery, arching fronds. The Areca thrives in bright, indirect light and adds a fresh tropical touch to any room.",
        gallery: [
            { src: indoor601, size: "xs" },
            { src: indoor602, size: "small" },
            { src: indoor603, size: "medium" },
            { src: indoor604, size: "large" },
            { src: indoor605, size: "xl" },
        ],
    },
    {
        id: 61,
        name: "Ficus Elastica Red",
        img: indoor61,
        description: "A bold rubber plant with deep burgundy leaves. It is hardy, stylish, and thrives in bright, indirect light with minimal care.",
        gallery: [
            { src: indoor611, size: "small" },
            { src: indoor612, size: "medium" },
        ],
    },
    {
        id: 62,
        name: "Ficus Elastica Green&White",
        img: indoor62,
        description: "A striking rubber plant with creamy white and green variegated leaves. It grows well in bright filtered light and adds elegance to indoor spaces.",
        gallery: [
            { src: indoor621, size: "small" },
            { src: indoor622, size: "medium" },
            { src: indoor623, size: "large" },
        ],
    },
    {
        id: 63,
        name: "Ficus Elastica Green",
        img: indoor63,
        description: "A classic, glossy-leaf rubber plant that is durable, low-maintenance, and perfect for modern homes and offices.",
        gallery: [
            { src: indoor631, size: "small" },
            { src: indoor632, size: "medium" },
        ],
    },
    {
        id: 64,
        name: "Bamboo Variegated",
        img: indoor64,
        description: "A decorative bamboo variety with attractive striped leaves. It enjoys bright indoor light and adds a fresh, calming look to any space.",
        gallery: [
            { src: indoor641 },
        ],
    },
    {
        id: 65,
        name: "Ficus Hawaii Tige",
        img: indoor65,
        description: "A tall, trunk-style ficus with lush patterned leaves. It brings height and freshness to interiors and thrives in bright indirect light.",
        gallery: [
            { src: indoor651, size: "small" },
            { src: indoor652, size: "medium" },
        ],
    },
    {
        id: 66,
        name: "Ficus Hawaii Touffe",
        img: indoor66,
        description: "A full, bushy ficus variety with dense variegated foliage. Ideal for bright indoor spaces that need a vibrant tropical touch.",
        gallery: [
            { src: indoor661 },
        ],
    },
    {
        id: 67,
        name: "Ficus Panda Tige",
        img: indoor67,
        description: "A sculpted ficus with an upright trunk and rounded green foliage. Elegant, easy to maintain, and perfect as a statement indoor plant.",
        gallery: [
            { src: indoor671 },
        ],
    },
    {
        id: 68,
        name: "Ficus Panda pyramid",
        img: indoor68,
        description: "A uniquely shaped ficus pruned into a pyramid form. Decorative and structured, it adds artistic greenery to any indoor space.",
        gallery: [
            { src: indoor681 },
        ],
    },
    {
        id: 69,
        name: "Ficus Panda boule",
        img: indoor69,
        description: "A beautifully rounded ficus shaped into a ball form. Low-maintenance and ideal for adding symmetry and style indoors.",
        gallery: [
            { src: indoor691 },
        ],
    },
    {
        id: 70,
        name: "Ficus Panda 3 heads",
        img: indoor70,
        description: "A multi-stem ficus featuring three rounded tops. Its sculpted structure makes it a standout decorative indoor plant.",
        gallery: [
            { src: indoor701 },
        ],
    },
    {
        id: 71,
        name: "Ficus Panda multi heads",
        img: indoor71,
        description: "A multi-headed ficus with several rounded foliage clusters, offering a lush, architectural look for modern interiors.",
        gallery: [
            { src: indoor711 },
        ],
    },

];



export default function IndoorsDesktop() {
    const navigate = useNavigate();

    const handleClick = (name: any) => {
        navigate(`/indoors/${name}`);
    };



    return (
        <div className="ficus-container" >
            <BackIcon />
            <div className="title-overlay" style={{ marginTop: "1rem" }}>
                <h1 className="title-modern">Indoors Collection</h1>
            </div>
            <div className="plants-category-container grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8" style={{ marginTop: "2rem" }}>
                {IndoorFamilies.map((indoor) => (
                    <div key={indoor.id} onClick={() => handleClick(indoor.name)} className=" ficus-shape-card bg-white p-6 rounded-xl shadow-lg transform transition-all hover:scale-105">
                        <img
                            src={indoor.img}
                            alt={indoor.name}
                            className="w-full h-60 object-cover rounded-lg mb-4"
                        />
                        <p className="plant-name">{indoor.name}</p>
                    </div>
                ))}
            </div>
        </div >
    );
}
